import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Card,
    Input,
    Select,
    Button,
    DatePicker,
    Radio,
    Steps,
    Table,
    Tag,
    Space,
    Row,
    Upload,
    message,
    InputNumber,
} from "antd";
import { Col } from "antd";
import { Form } from "antd";
import { CloudDownloadOutlined, DeleteOutlined, EditOutlined, SaveOutlined, UploadOutlined } from "@ant-design/icons";
import { AppDispatch, RootState } from "../../../../store/store";
import dayjs from "dayjs";
import { createAyushBPreAuth, fetchDiagnosis, postAyushBPreAuth, updateAyushBClaim, updateAyushBPreAuth } from "../../../../apis/ayushmanBService";
import { errorMessage } from "../../../../utils/notificationUtils";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { getDiagnosis, getDoctors, getImplants, getInvestigations, getStratifications } from "../../../../models/ayushmanBSlice";
import { Typography } from "antd";

const { Option } = Select;
const { Step } = Steps;
const { Search } = Input;
const { Text } = Typography;
// interface Diagnosis {
//     key: string;
//     no: string;
//     diagnosisCode: string;
//     diagnosis: string;
//     diagnosisId: string;
//     type: string;
// }
interface TreatmentPlanPayload {
    speciality: string;
    procedure: string;
    stratification: string;
    numberOfDaysPerUnits: number | null;
    // ichiCode: string;
}
interface TreatmentPlan {
    speciality: JsonObject;
    procedure: JsonObject;
    stratification: JsonObject;
    numberOfDaysPerUnits: number | null;
    // ichiCode: string;
}
interface Implant {
    implant: {
        id: number;
        name: string;
        amount: number;
        code: string;
    } | null;
    quantity: number | null;
    document: IDocumentFields | null;
}
interface dataSource {
    key: string;
    documentType: string;
    document: string;
    deficiency: string;
    deficiencyType: string;
}

type AyushB = {
    activeStep: number;
    handleNext: () => void;
    handlePrevious: () => void;
    handleGetData: () => void;
    handleModalOpen: () => void;
    handleUploadFile: any;
    form: any;
    setSelectedDocumentType: any;
    setActiveDocListType: any;
    activeDocListType: string;
    selectedDocumentType: any;
    setUploadedInvestigationFileList: any;
    setUploadedImplantFileList: any;
    uploadedImplantFileList: any;
    uploadedInvestigationFileList: any;
    uploadedFileColumns: any;
    stageStatus: number | null;
    nextStage: any;
    setMoveToNext: CallableFunction;
};

interface TabType {
    id: number;
    label: string;
    value: string;
}
interface DiagnosisOption {
    theCode: string;
    title: string;
}

interface DiagnosisData {
    diagnosis: string;
    // diagnosisId: string;
    diagnosisCode: string;
    type: string;
}

interface JsonObject {
    [key: string]: any;
}

const dateFormat = "DD-MM-YYYY HH:mm:ss";

// const categoryData: Record<string, DiagnosisOption[]> = {
//     blood: [
//         { diagnosisCode: "QB51.7", diagnosis: "Complete Blood Count", diagnosisId: "cbc" },
//         { diagnosisCode: "QB51.8", diagnosis: "Blood Glucose Test", diagnosisId: "glucose" },
//     ],
//     imaging: [
//         { diagnosisCode: "IM20.3", diagnosis: "X-Ray", diagnosisId: "xray" },
//         { diagnosisCode: "IM40.5", diagnosis: "MRI Scan", diagnosisId: "mri" },
//     ],
//     other: [
//         { diagnosisCode: "OT10.2", diagnosis: "Biopsy", diagnosisId: "biopsy" },
//         { diagnosisCode: "OT30.1", diagnosis: "ECG Test", diagnosisId: "ecg" },
//     ],
// };

const implantSampleData = [
    { id: 1, name: "Implant ABC XYZ", amount: 2020, code: "1" },
    { id: 2, name: "Implant DEF GHI", amount: 3050, code: "2" },
    { id: 3, name: "Implant JKL MNO", amount: 4120, code: "3" },
    { id: 4, name: "Implant PQR STU", amount: 2785, code: "4" },
    { id: 5, name: "Implant VWX YZA", amount: 3500, code: "5" },
    { id: 6, name: "Implant BCD EFG", amount: 1890, code: "6" },
    { id: 7, name: "Implant HIJ KLM", amount: 2560, code: "7" },
    { id: 8, name: "Implant NOP QRS", amount: 4820, code: "8" },
    { id: 9, name: "Implant TUV WXY", amount: 3200, code: "9" },
    { id: 10, name: "Implant ZAB CDE", amount: 2900, code: "10" }
];

// Define tabs for each step
const medicalTabs = [
    { id: 0, label: "GENERAL FINDINGS", value: "GENERAL_FINDINGS" },
    { id: 1, label: "FAMILY FINDINGS", value: "FAMILY_FINDINGS" },
    { id: 2, label: "PERSONAL HISTORY", value: "PERSONAL_HISTORY" }
];
const admissionTabs = [
    { id: 0, label: "ADMISSION DETAILS", value: "ADMISSION_DETAILS" },
];

const treatmentTabs = [
    { id: 0, label: "DIAGONSIS", value: "DIAGONSIS" },
    { id: 1, label: "TREATMENT PLAN", value: "TREATMENT_PLAN" },
    { id: 2, label: "IMPLANT", value: "IMPLANT" },
    { id: 3, label: "INVESTIGATIONS", value: "INVESTIGATIONS" },
    { id: 4, label: "CARE TEAM DETAILS", value: "CARE_TEAM_DETAILS" },
];


const parseDateSafely = (dateString: string) => {
    if (!dateString) return "";

    // Try to parse the date
    const parsed = dayjs(dateString, dateFormat);
    // For DD-MM-YYYY HH:mm:ss format which might not be recognized automatically
    if (!parsed.isValid()) {
        return dayjs(dateString, "DD-MM-YYYY HH:mm:ss");
    }

    return parsed;
};

const styles: Record<string, React.CSSProperties> = {
    mainContent: {
        minHeight: "64px",
        background: "rgb(243, 243, 243)",
        padding: "12px 25px", // Removed the semicolon and fixed the gap
        gap: "42px", // Added the gap as a separate property
        borderRadius: "16px 16px 0px 0px", // Fixed camelCase
        borderBottom: "1px solid rgb(166, 166, 166)",
        fontWeight: "600",
        fontSize: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    statusDesign: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "20px",
        minWidth: "676px",
        maxHeight: "36px",
    },
    editAndSaveButtonDesign: {
        float: "right",
        position: "sticky",
        top: 0,
        backgroundColor: "white",
        zIndex: 1000,
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        padding: "10px 0",
        margin: "0px 55px"
    },
    continueButton: {
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 25px",
        textTransform: "uppercase",
        color: "white",
    },
    saveEditButton: {
        color: "white",
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
    },
    editButton: {
        color: "#008B8B",
        background: "white",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
    },
    previousButton: {
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 25px",
        textTransform: "uppercase",
        color: "white",
        marginRight: "10px",
    },
    submitButton: {
        marginRight: "10px",
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 25px",
        textTransform: "uppercase",
        color: "white",
    },
};

export const PreAuthAyush: React.FC<AyushB> = (props) => {
    const dispatch = useDispatch<AppDispatch>();
    const { ayushBPreAuth, patients } = useSelector(
        (state: RootState) => state
    );

    const [disabledForm, setDisabledForm] = useState(false);
    const [casePreAuthId, setCasePreAuthId] = useState(null);

    const admissionDateValue = Form.useWatch('admissionDate', props?.form)
    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId = patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
    const portalMetaData = patients?.schemeMetaData;
    const specialities = useMemo(() => ayushBPreAuth?.preAuth?.specialities || [], [ayushBPreAuth?.preAuth?.specialities])
    const procedures = useMemo(() => ayushBPreAuth?.preAuth?.procedures || [], [ayushBPreAuth?.preAuth?.procedures])
    const stratifications = useMemo(() => ayushBPreAuth?.preAuth?.stratifications || [], [ayushBPreAuth?.preAuth?.stratifications])
    const doctors = useMemo(() => ayushBPreAuth?.preAuth?.doctors || [], [ayushBPreAuth?.preAuth?.doctors])
    const [treatmentPlansData, setTreatmentPlansData] = useState<TreatmentPlan[]>([]);

    const [implantData, setImplantData] = useState<Implant[]>([
        {
            implant: {
                id: 1,
                name: "Implant ABC XYZ",
                amount: 2020,
                code: "1"
            },
            quantity: 2,
            document: {
                "documentType": "28",
                "documentName": "DD (3).pdf",
                "documentUrl": "https://edgepro-dev-document.s3.ap-south-1.amazonaws.com/hospital%2F81%2Fpatient%2F2996%2Fcase%2F5640%2F28%2F28_26-03-2025+06%3A00%3A57_DD+%283%29.pdf",
                "id": 49099,
                "referenceType": "casePreAuth",
                "documentLabelType": "CLINICAL NOTES",
                "deficiencyCheckStatus": false,
                "remark": ""
            }
        }
    ]);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [manualDoctorDetails, setManualDoctorDetails] = useState({
        name: '',
        registrationId: '',
        qualification: '',
        mobile: ''
    });
    const [isUnspecifiedProcedure, setIsUnspecifiedProcedure] = useState<boolean>(false);
    const [diagnosisCount, setDiagnosisCount] = useState<number>(2);
    const [treatmentPlanCount, setTreatmentPlanCount] = useState<number>(2);
    const [newDiagnosis, setNewDiagnosis] = useState<DiagnosisData>({
        diagnosis: "",
        // diagnosisId: "",
        diagnosisCode: "",
        type: "Primary",
    });
    const [category, setCategory] = useState<string>("");
    const [diagnosisOptions, setDiagnosisOptions] = useState<DiagnosisOption[]>([]);
    const [newTreatmentPlan, setNewTreatmentPlan] = useState<TreatmentPlan>({
        speciality: {},
        procedure: {},
        stratification: {},
        numberOfDaysPerUnits: 1,
        // ichiCode: "",
    });

    const [newImplant, setNewImplant] = useState<Omit<Implant, "key" | "no" | "document">>({
        implant: null,
        quantity: 1,
    });

    // State to track the active tab for each step
    const [activeMedicalTab, setActiveMedicalTab] = useState<TabType>(medicalTabs[0]);
    const [activeAdmissionTab, setActiveAdmissionTab] = useState<TabType>(admissionTabs[0]);
    const [activeTreatmentTab, setActiveTreatmentTab] = useState<TabType>(treatmentTabs[0]);

    const [diagnosisData, setDiagnosisData] = useState<DiagnosisData[]>([
        // {
        //     diagnosisCode: "QB51.8",
        //     diagnosis: "Blood Glucose Test",
        //     // diagnosisId: "glucose",
        //     type: "Primary"
        // },
    ]);

    const parseDate = (dateString: any) => {
        if (!dateString) return null; // Ensure null is returned if empty
        return dayjs(dateString, dateFormat).isValid()
            ? dayjs(dateString, dateFormat) // Custom format
            : dayjs(dateString); // Default ISO format
    };

    const mapApiResponseToState = (apiResponse: any) => ({
        temperature: apiResponse?.temperature || "100",
        pulseRatePerMinute: apiResponse?.pulseRatePerMinute || "72",
        height: apiResponse?.height || "170",
        weight: apiResponse?.weight || "70",
        // bmi: apiResponse?.bmi || "",
        cyanosis: apiResponse?.cyanosis ?? "No",
        pallor: apiResponse?.pallor ?? "No",
        malnutrition: apiResponse?.malnutrition ?? "No",
        oedema: apiResponse?.oedema ?? "No",
        diabetes: apiResponse?.diabetes || "None",
        hypertension: apiResponse?.hypertension || "None",
        heartDisease: apiResponse?.heartDisease || "None",
        stroke: apiResponse?.stroke || "None",
        cancer: apiResponse?.cancer || "None",
        tuberculosis: apiResponse?.tuberculosis || "None",
        asthma: apiResponse?.asthma || "None",
        diet: apiResponse?.diet || "Normal",
        nutrition: apiResponse?.nutrition || "Normal",
        appetite: apiResponse?.appetite || "Normal",
        bowels: apiResponse?.bowels || "Normal",
        allergies: apiResponse?.allergies ?? "No",
        habitsAddictions: apiResponse?.habitsAddictions ?? "No",

        // Convert Dayjs object to string
        // admissionDate: apiResponse?.admissionDate ? parseDate(apiResponse?.admissionDate) : null,
        // surgeryTreatmentStartDate: apiResponse?.surgeryDate ? parseDate(apiResponse?.surgeryDate) : null,
        // admissionDate: apiResponse?.admissionDate ? parseDateSafely(apiResponse?.admissionDate) : "",
        // surgeryDate: apiResponse?.surgeryDate ? parseDateSafely(apiResponse?.surgeryDate) : "",
        admissionDate: apiResponse?.admissionDate ?
            parseDateSafely(apiResponse?.admissionDate) :
            patients?.fetchBasicDetails?.visitInfoResponse?.doa ?
                parseDateSafely(patients?.fetchBasicDetails?.visitInfoResponse?.doa) :
                null,
        surgeryDate: apiResponse?.surgeryDate ?
            parseDateSafely(apiResponse?.surgeryDate) :
            patients?.fetchBasicDetails?.visitInfoResponse?.doa ?
                parseDateSafely(patients?.fetchBasicDetails?.visitInfoResponse?.doa) :
                null,
        admissionType: apiResponse?.admissionType || "Planned",
        medicoLegalCase: apiResponse?.medicoLegalCase || "No",

        // Treatment Information
        // diagnosis: apiResponse?.diagnosis || "",
        // diagnosisType: apiResponse?.diagnosisType || "Primary",
        // speciality: apiResponse?.speciality || "",
        // procedure: apiResponse?.procedure || "",
        // noOfDaysAndUnits: apiResponse?.noOfDaysAndUnits || "",
        // ichiCode: apiResponse?.ichiCode || "",
        doctorName: apiResponse?.doctorName || "",
        doctorRegistrationId: apiResponse?.doctorRegistrationId || "",
        doctorQualification: apiResponse?.doctorQualification || "",
        doctorMobileNo: apiResponse?.doctorMobileNo || "",
    });

    const mapTreatmentPlanData = (treatmentPlanResponse: TreatmentPlan[]) => {
        setTreatmentPlansData(treatmentPlanResponse);
    }
    const mapDiagnosisData = (DiagnosisResponse: DiagnosisData[]) => {
        setDiagnosisData(DiagnosisResponse);
    }

    useEffect(()=>{
        const match = treatmentPlansData?.some((item)=>
            item?.procedure?.name?.toLowerCase()?.includes("unspecified")
        )
        setIsUnspecifiedProcedure(match)
    },[treatmentPlansData])

    useEffect(() => {
        if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.id) {
            setCasePreAuthId(ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.id || null)
            setDisabledForm(true)
        }
    }, [ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.id])

    useEffect(() => {
        // if (ayushBPreAuth?.portalData) {
        props?.form.setFieldsValue(mapApiResponseToState(ayushBPreAuth?.portalData?.casePreAuthOthersResponse || {}))
        // }
        if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData?.length > 0) {
            mapTreatmentPlanData(ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData)
        }
        if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.diagnosisData?.length > 0) {
            mapDiagnosisData(ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.diagnosisData)
        }
    }, [ayushBPreAuth.portalData]);

    useEffect(() => {
        if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.doctorRegistrationId && doctors) {
            const docValue = doctors.find(doc => doc.docregnum == ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.doctorRegistrationId)
            setSelectedDoctor(docValue?.docid || "OTHER")
        }
    }, [ayushBPreAuth.portalData, doctors]);

    useEffect(() => {
        if (ayushBPreAuth?.preAuth?.diagnosis?.length > 0) {
            setDiagnosisOptions(ayushBPreAuth?.preAuth?.diagnosis);
        } else {
            setDiagnosisOptions([]);
        }
    }, [ayushBPreAuth?.preAuth?.diagnosis])

    useEffect(() => {
        if (diagnosisData?.length > 0) {
            setNewDiagnosis({
                diagnosis: "",
                // diagnosisId: "",
                diagnosisCode: "",
                type: diagnosisData.some(item => item?.type == "Primary") ? "Secondary" : "Primary",
            });
        }
    }, [diagnosisData])

    useEffect(() => {
        if (treatmentPlansData?.length > 0 && activeTreatmentTab.id === 3) {
            const procedureCodeList = treatmentPlansData?.map(item => {
                return item?.procedure?.id
            });

            const investigationPlayload = {
                procedureCodes: procedureCodeList,
                investigationStage: "Pre"
            }
            if (portalMetaData?.portalMetaDataIdsList[0] && investigationPlayload) {
                dispatch(getInvestigations({ portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0], data: investigationPlayload }))
            }
        }
        if (treatmentPlansData?.length > 0 && activeTreatmentTab.id === 2) {
            const procedureCodeList = treatmentPlansData?.map(item => {
                return item?.procedure?.id
            });

            const implantPlayload = {
                procedureCodes: procedureCodeList,
            }
            if (portalMetaData?.portalMetaDataIdsList[0] && implantPlayload) {
                dispatch(getImplants({ portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0], data: implantPlayload }))
            }
        }
        if (treatmentPlansData?.length > 0 && activeTreatmentTab.id === 4) {
            const specialityList = treatmentPlansData?.map(item => {
                return item?.speciality?.name
            });

            const doctorsPlayload = {
                specialityCodes: specialityList,
            }
            if (portalMetaData?.portalMetaDataIdsList[0] && doctorsPlayload) {
                dispatch(getDoctors({ portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0], data: doctorsPlayload }))
            }
        }
    }, [activeTreatmentTab])

    useEffect(() => {
        if (activeTreatmentTab.id === 2) {
            props?.setActiveDocListType("implant")
        }
        if (activeTreatmentTab.id === 3) {
            props?.setActiveDocListType("investigation")
        }
    }, [activeTreatmentTab])

    const renderMedicalForm = () => {
        return (
            <>
                <div style={{ display: "flex", padding: "0 55px", marginTop: "10px" }}>
                    {medicalTabs.map((tab, index) => (
                        <Button
                            key={index}
                            type={activeMedicalTab.id === tab.id ? "primary" : "default"}
                            onClick={() => handleMedicalTabChange(tab)}
                            style={getTabButtonStyle(activeMedicalTab.id === tab.id)}
                        >
                            {tab.label}
                        </Button>
                    ))}
                </div>
                <div style={{ padding: "15px", border: "1px solid #f0f0f0", margin: "0 55px" }}>
                    <Form
                        form={props?.form}
                        layout="vertical"
                        name="medicalForm"
                        disabled={disabledForm}
                        style={{ padding: "15px 0" }}
                    >
                        <div
                            hidden={!(activeMedicalTab.id === 0)}
                        >
                            {renderGeneralFindingsForm()}
                        </div>
                        <div
                            hidden={!(activeMedicalTab.id === 1)}
                        >
                            {renderFamilyFindingsForm()}
                        </div>
                        <div
                            hidden={!(activeMedicalTab.id === 2)}
                        >
                            {renderPersonalHistoryForm()}
                        </div>
                        {/* {activeMedicalTab.id === 0 && renderGeneralFindingsForm()}
                        {activeMedicalTab.id === 1 && renderFamilyFindingsForm()}
                        {activeMedicalTab.id === 2 && renderPersonalHistoryForm()} */}
                    </Form>
                </div>
            </>
        )
    }

    const renderGeneralFindingsForm = () => {
        return (
            <>
                <Row gutter={20}>
                    <Col span={8}>
                        <Form.Item
                            name="temperature"
                            label="Temperature (°F)"
                            rules={[
                                { required: true, message: 'Please enter temperature' },
                                { pattern: /^[0-9.]+$/, message: 'Please enter numeric values only' }
                            ]}
                        >
                            <Input placeholder="Enter Temperature in °F" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="pulseRatePerMinute"
                            label="Pulse Rate Per Minute"
                            rules={[
                                { required: true, message: 'Please enter pulse rate' },
                                { pattern: /^[0-9.]+$/, message: 'Please enter numeric values only' }
                            ]}
                        >
                            <Input placeholder="Enter Pulse Rate" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="height"
                            label="Height (cm)"
                            rules={[
                                { required: true, message: 'Please enter height' },
                                { pattern: /^[0-9.]+$/, message: 'Please enter numeric values only' }
                            ]}
                        >
                            <Input placeholder="Enter Height in cm" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="weight"
                            label="Weight (kg)"
                            rules={[
                                { pattern: /^[0-9.]+$/, message: 'Please enter numeric values only' }
                            ]}
                        >
                            <Input placeholder="Enter Weight in kg" />
                        </Form.Item>
                    </Col>
                    {/* <Col span={8}>
                        <Form.Item
                            name="bmi"
                            label="BMI"
                        >
                            <Input placeholder="Enter BMI" disabled style={{ backgroundColor: "#f9f0ff" }} />
                        </Form.Item>
                    </Col> */}
                    <Col span={8}>
                        <Form.Item
                            name="cyanosis"
                            label="Cyanosis"
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="pallor"
                            label="Pallor"
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="malnutrition"
                            label="Malnutrition"
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="oedema"
                            label="Oedema in Feet"
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </>
        )
    }

    const renderFamilyFindingsForm = () => {
        return (
            <>
                <Row gutter={20}>
                    <Col span={8}>
                        <Form.Item
                            name="diabetes"
                            label="Diabetes"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="hypertension"
                            label="Hypertension"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="heartDisease"
                            label="Heart Disease"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="stroke"
                            label="Stroke"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="cancer"
                            label="Cancer"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="tuberculosis"
                            label="Tuberculosis"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="asthma"
                            label="Asthma"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Select placeholder="Select">
                                <Option value="None">None</Option>
                                <Option value="Self">Self</Option>
                                <Option value="Family">Family</Option>
                                <Option value="Both">Both Self and Family</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </>
        )
    }

    const renderPersonalHistoryForm = () => {
        return (
            <>
                <Row gutter={20}>
                    <Col span={6}>
                        <Form.Item
                            name="diet"
                            label="Diet"
                            rules={[{ required: true, message: 'Please select diet type' }]}
                        >
                            <Select placeholder="Select">
                                <Select.Option value="Normal">Normal</Select.Option>
                                <Select.Option value="Constipation">Constipation</Select.Option>
                                <Select.Option value="Loose">Loose</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nutrition"
                            label="Nutrition"
                            rules={[{ required: true, message: 'Please select nutrition type' }]}
                        >
                            <Select placeholder="Select">
                                <Select.Option value="Normal">Normal</Select.Option>
                                <Select.Option value="Constipation">Constipation</Select.Option>
                                <Select.Option value="Loose">Loose</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="appetite"
                            label="Appetite"
                            rules={[{ required: true, message: 'Please select appetite type' }]}
                        >
                            <Select placeholder="Select">
                                <Select.Option value="Normal">Normal</Select.Option>
                                <Select.Option value="Constipation">Constipation</Select.Option>
                                <Select.Option value="Loose">Loose</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="bowels"
                            label="Bowels"
                            rules={[{ required: true, message: 'Please select bowels type' }]}
                        >
                            <Select placeholder="Select">
                                <Select.Option value="Normal">Normal</Select.Option>
                                <Select.Option value="Constipation">Constipation</Select.Option>
                                <Select.Option value="Loose">Loose</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={20}>
                    <Col span={6}>
                        <Form.Item
                            name="allergies"
                            label="Known Allergies"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="habitsAddictions"
                            label="Habits Addictions"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </>
        )
    }

    const renderAdmissionForm = () => {
        return (
            <>
                <div style={{ display: "flex", padding: "0 55px", marginTop: "10px" }}>
                    {admissionTabs.map((tab, index) => (
                        <Button
                            key={index}
                            type={activeAdmissionTab.id === tab.id ? "primary" : "default"}
                            onClick={() => handleAdmissionTabChange(tab)}
                            style={getTabButtonStyle(activeAdmissionTab.id === tab.id)}
                        >
                            {tab.label}
                        </Button>
                    ))}
                </div>
                <div style={{ padding: "15px", border: "1px solid #f0f0f0", margin: "0 55px" }}>
                    <Form
                        form={props?.form}
                        layout="vertical"
                        name="admissionForm"
                        disabled={disabledForm}
                        style={{ padding: "15px 0" }}
                    >
                        <div
                            hidden={!(activeAdmissionTab.id === 0)}
                        >
                            {renderAdmissionDetailsForm()}
                        </div>
                    </Form>
                </div>
            </>
        )
    }

    const renderAdmissionDetailsForm = () => {
        return (
            <>
                <Row gutter={20}>
                    <Col span={6}>
                        <Form.Item
                            name="admissionDate"
                            label="Admission Date"
                            rules={[{ required: true, message: 'Please select admission date' }]}
                        >
                            <DatePicker
                                allowClear
                                style={{ width: "100%" }}
                                showTime
                                format={dateFormat}
                                disabledDate={(current) => {
                                    const today = dayjs();
                                    today.startOf('day');

                                    const twoDaysAgo = dayjs().subtract(2, 'day').startOf('day');

                                    return current && (current.isBefore(twoDaysAgo) || current.isAfter(today));
                                }}
                                onChange={() => {
                                    props?.form.setFieldsValue({ surgeryDate: null });
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="surgeryDate"
                            label="Surgery Treatment Start Date"
                            rules={[{ required: true, message: 'Please select surgery date' }]}
                        >
                            <DatePicker
                                allowClear
                                style={{ width: "100%" }}
                                showTime
                                format={dateFormat}
                                disabled={!admissionDateValue || props?.form.disabled}
                                disabledDate={(current) => {
                                    const admissionDate = props?.form.getFieldValue('admissionDate');
                                    if (!admissionDate) return true;

                                    const admissionDayjs = dayjs.isDayjs(admissionDate) ? admissionDate : dayjs(admissionDate);

                                    const maxDate = admissionDayjs.add(10, 'day').endOf('day');

                                    return current && (current.isBefore(admissionDayjs.startOf('day')) || current.isAfter(maxDate));
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="admissionType"
                            label="Admission Type"
                            rules={[{ required: true, message: 'Please select admission type' }]}
                        >
                            <Select placeholder="Select">
                                <Select.Option value="Planned">PLANNED</Select.Option>
                                <Select.Option value="Emegency">EMERGENCY</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="medicoLegalCase"
                            label="Medico Legal Case"
                            rules={[{ required: true, message: 'Please select an option' }]}
                        >
                            <Radio.Group>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </>
        )
    }

    const renderTreatmentForm = () => {
        return (
            <>
                <div style={{ display: "flex", padding: "0 55px", marginTop: "10px" }}>
                    {treatmentTabs?.map((tab, index) => (
                        <Button
                            key={index}
                            type={activeTreatmentTab.id === tab.id ? "primary" : "default"}
                            onClick={() => handleTreatmentTabChange(tab)}
                            style={getTabButtonStyle(activeTreatmentTab.id === tab.id)}
                        >
                            {tab.label}
                        </Button>
                    ))}
                </div>
                <div style={{ padding: "15px", border: "1px solid #f0f0f0", margin: "0 55px" }}>
                    <Form
                        form={props?.form}
                        layout="vertical"
                        name="treatmentForm"
                        disabled={disabledForm}
                        style={{ padding: "15px 0" }}
                    >
                        <div
                            hidden={!(activeTreatmentTab.id === 0)}
                        >
                            {renderDiagonsisForm()}
                        </div>
                        <div
                            hidden={!(activeTreatmentTab.id === 1)}
                        >
                            {renderTreatmentPlanForm()}
                        </div>
                        <div
                            hidden={!(activeTreatmentTab.id === 2)}
                        >
                            {renderImplantPlanForm()}
                        </div>
                        <div
                            hidden={!(activeTreatmentTab.id === 3)}
                        >
                            {renderInvestigationForm()}
                        </div>
                        <div
                            hidden={!(activeTreatmentTab.id === 4)}
                        >
                            {renderCareTeamDetailsForm()}
                        </div>
                    </Form>
                </div>
            </>
        )
    }

    const renderDiagonsisForm = () => {
        return (
            <>
                <Row gutter={20}>
                    {/* Search Category Input */}
                    <Col span={6}>
                        <Form.Item label="Search Diagnosis">
                            <Search
                                placeholder="Type here"
                                loading={ayushBPreAuth?.isFetchingData}
                                onSearch={(value) => handleCategorySearch(value)}
                            />
                            {/* <Input
                                placeholder="Type here"
                                value={category}
                                onChange={(e) => handleCategorySearch(e.target.value)}
                            /> */}
                        </Form.Item>
                    </Col>

                    {/* Select Diagnosis Dropdown */}
                    <Col span={6}>
                        <Form.Item
                            // name="diagnosis" 
                            label="Select Diagnosis">
                            <Select
                                showSearch
                                placeholder="Select"
                                style={{ width: "100%" }}
                                value={newDiagnosis?.diagnosisCode || null}
                                onChange={handleDiagnosisSelect}
                                disabled={!(diagnosisOptions?.length > 0) || disabledForm}
                                filterOption={(input, option) =>
                                    (option?.label as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                    (option?.value as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                    (option?.data?.theCode as string)?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {diagnosisOptions.map((option, index) => {
                                    const fullText = `${option?.title} | (${option?.theCode})`;
                                    return (
                                        <Option key={index} value={option?.theCode} label={fullText} data={option}>
                                            {fullText}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                    </Col>

                    {/* Diagnosis Type Selection */}
                    <Col span={6}>
                        <Form.Item
                            // name="diagnosisType"
                            label="Diagnosis Type"
                            rules={[{ required: true, message: "Please select diagnosis type" }]}
                        >
                            <Radio.Group
                                value={newDiagnosis?.type || null}
                                onChange={(e) => setNewDiagnosis((prev) => ({ ...prev, type: e.target.value }))}
                            >
                                {
                                    !diagnosisData.some(item => item?.type == "Primary") &&
                                    <Radio value="Primary">Primary</Radio>
                                }
                                <Radio value="Secondary">Secondary</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>

                    {/* Add Button */}
                    <Col span={6} style={{ display: "flex", alignItems: "center" }}>
                        <Button
                            style={{ width: "100px", color: "white", backgroundColor: "rgb(0, 139, 139)" }}
                            onClick={handleAddDiagnosis}
                            disabled={!newDiagnosis.diagnosis || !newDiagnosis.type}
                        >
                            ADD
                        </Button>
                    </Col>
                </Row>

                <div className="tableOfPreAuth">
                    <Card>
                        <Table
                            dataSource={diagnosisData}
                            columns={DiagonsisColumns}
                            pagination={false}
                            bordered
                            style={{
                                // width: "95%",
                                // margin: "10px auto",
                                textAlign: "center",
                            }}
                        />
                    </Card>
                </div>
            </>
        )
    }

    const renderTreatmentPlanForm = () => {
        return (
            <>
                {
                    !isUnspecifiedProcedure ?
                        <>
                            <Row gutter={20}>
                                <Col span={6}>
                                    <Form.Item label="Speciality">
                                        <Select
                                            showSearch
                                            placeholder="Select"
                                            style={{ width: "100%" }}
                                            optionFilterProp="children"
                                            value={newTreatmentPlan?.speciality?.id || null}
                                            onChange={(_: string, option: any) => handleTreatmentDataChange('speciality', option)}
                                            filterOption={(input, option) =>
                                                (option?.label as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                                (option?.value as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                                (option?.data?.specialitycode as string)?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {specialities.map((speciality, index) => (
                                                <Option
                                                    key={index}
                                                    value={speciality?.specialityid}
                                                    label={speciality?.speciality}
                                                    data={speciality}
                                                >
                                                    {speciality?.speciality}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={6}>
                                    <Form.Item label="Procedure">
                                        <Select
                                            showSearch
                                            style={{ width: "100%" }}
                                            placeholder="Select a procedure"
                                            optionFilterProp="children"
                                            value={newTreatmentPlan?.procedure?.id || null}
                                            onChange={(_: string, option: any) => handleTreatmentDataChange('procedure', option)}
                                            filterOption={(input, option) =>
                                                (option?.label as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                                (option?.value as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                                (option?.data?.procedurecode as string)?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {procedures.map((procedure, index) => (
                                                <Option
                                                    key={index}
                                                    value={procedure?.procedurecode}
                                                    label={procedure?.procedurename}
                                                    data={procedure}
                                                >
                                                    {procedure?.procedurename}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {
                                    newTreatmentPlan?.procedure?.name?.toLowerCase()?.includes("unspecified") &&
                                    (
                                        <>
                                            <Col span={6}>
                                                <Form.Item label="Procedure Name">
                                                    <Input
                                                        placeholder="Enter Procedure Name"
                                                        value={newTreatmentPlan?.procedure?.procedureName || ""}
                                                        onChange={(e) => handleTreatmentDataChange('procedureName', e?.target?.value || '')}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col span={6}>
                                                <Form.Item label="Procedure Amount">
                                                    <InputNumber
                                                        placeholder="Enter Procedure Amount"
                                                        value={newTreatmentPlan?.procedure?.amount}
                                                        onChange={(value) => handleTreatmentDataChange('procedureAmount', value || '')}
                                                        min={0}
                                                        max={500000}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </>
                                    )
                                }

                                {procedures.find(i => i.procedurecode == newTreatmentPlan.procedure?.id)?.isstratificationapplicable === "Y" && (
                                    <Col span={6}>
                                        <Form.Item label="Stratification">
                                            <Select
                                                showSearch
                                                placeholder="Select"
                                                style={{ width: "100%" }}
                                                optionFilterProp="children"
                                                value={newTreatmentPlan?.stratification?.id || null}
                                                onChange={(_: string, option: any) => handleTreatmentDataChange('stratification', option)}
                                                filterOption={(input, option) =>
                                                    (option?.label as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                                    (option?.value as string)?.toLowerCase().includes(input.toLowerCase()) ||
                                                    (option?.data?.stratificationcode as string)?.toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {stratifications.map((stratification, index) => (
                                                    <Option
                                                        key={index}
                                                        value={stratification?.stratificationCode}
                                                        label={stratification?.stratificationName}
                                                        data={stratification}
                                                    >
                                                        {stratification?.stratificationName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                )}

                                <Col span={6}>
                                    <Form.Item label="No. of Days/Units">
                                        <InputNumber
                                            placeholder="Enter Detail"
                                            value={newTreatmentPlan?.numberOfDaysPerUnits || 1}
                                            min={0}
                                            onChange={(value) => handleTreatmentDataChange('numberOfDaysPerUnits', value || '')}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} style={{ display: "flex", justifyContent: "end" }}>
                                    <Button
                                        style={{
                                            width: "100px",
                                            color: "white",
                                            backgroundColor: "rgb(0, 139, 139)",
                                            marginBottom: "10px",
                                        }}
                                        onClick={handleAddTreatmentPlan}
                                    >
                                        ADD
                                    </Button>
                                </Col>
                            </Row>
                        </> :
                        <div style={{ textAlign: 'center', marginTop: 16, marginBottom: 16 }}>
                            <Text type="danger">
                                No more TreatmentPlan after selecting the unspecified one
                            </Text>
                        </div>
                }

                <div className="tableOfPreAuth">
                    <Card>
                        <Table
                            dataSource={treatmentPlansData}
                            columns={TreatmentPlanColumns}
                            pagination={false}
                            bordered
                            style={{
                                // width: "95%", 
                                // margin: "10px auto", 
                                textAlign: "center"
                            }}
                        />
                    </Card>
                </div>
            </>
        );
    };

    const renderImplantPlanForm = () => {
        return (
            <>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "2%",
                        }}
                    >
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: "#008B8B",
                                color: "#fff",
                                boxShadow: "0px 2px 8px 0px #00000040",
                                marginTop: "10px",
                            }}
                            onClick={props?.handleModalOpen}
                        >
                            Upload document
                        </Button>
                    </div>
                    {/* <Row>
                        <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "15px" }}>
                            <Form.Item
                                // name="documentType"
                                noStyle
                            >
                                <Select
                                    placeholder="Select Document Type"
                                    style={{ width: 200 }}
                                    onChange={(value) => props?.setSelectedDocumentType(value)}
                                >
                                    <Option value={28}>CLINICAL NOTES</Option>
                                </Select>
                            </Form.Item>

                            <Upload
                                beforeUpload={() => false}
                                maxCount={1}
                                onChange={(info) =>
                                    props?.handleUploadFile && props?.handleUploadFile(props?.selectedDocumentType)(info)
                                }
                                showUploadList={false}
                            >
                                <Button
                                    type="primary"
                                    icon={<UploadOutlined />}
                                    style={{
                                        backgroundColor: "#008B8B",
                                        color: "#fff",
                                        boxShadow: "0px 2px 8px 0px #00000040",
                                    }}
                                    disabled={!props?.selectedDocumentType}
                                >
                                    Upload Document
                                </Button>
                            </Upload>
                        </Col>
                    </Row> */}
                    {
                        // props?.uploadedFileList.length > 0 &&
                        <div className="tableOfPreAuth">
                            <Card style={{ margin: "20px 30px" }}>
                                <Table
                                    dataSource={props?.uploadedImplantFileList || []}
                                    columns={props?.uploadedFileColumns}
                                    pagination={false}
                                    bordered
                                    style={{
                                        // width: "95%",
                                        // margin: "10px auto",
                                        textAlign: "center",
                                    }}
                                />
                            </Card>
                        </div>}
                </div>
            </>
        )
    }

    const renderInvestigationForm = () => {
        return (
            <>
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "2%",
                        }}
                    >
                        <Button
                            type="primary"
                            style={{
                                backgroundColor: "#008B8B",
                                color: "#fff",
                                boxShadow: "0px 2px 8px 0px #00000040",
                                marginTop: "10px",
                            }}
                            onClick={props?.handleModalOpen}
                        >
                            Upload document
                        </Button>
                    </div>
                    {/* <Row>
                        <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "15px" }}>
                            <Form.Item
                                // name="documentType"
                                noStyle
                            >
                                <Select
                                    placeholder="Select Document Type"
                                    style={{ width: 200 }}
                                    onChange={(value) => props?.setSelectedDocumentType(value)}
                                >
                                    <Option value={28}>CLINICAL NOTES</Option>
                                </Select>
                            </Form.Item>

                            <Upload
                                beforeUpload={() => false}
                                maxCount={1}
                                onChange={(info) =>
                                    props?.handleUploadFile && props?.handleUploadFile(props?.selectedDocumentType)(info)
                                }
                                showUploadList={false}
                            >
                                <Button
                                    type="primary"
                                    icon={<UploadOutlined />}
                                    style={{
                                        backgroundColor: "#008B8B",
                                        color: "#fff",
                                        boxShadow: "0px 2px 8px 0px #00000040",
                                    }}
                                    disabled={!props?.selectedDocumentType}
                                >
                                    Upload Document
                                </Button>
                            </Upload>
                        </Col>
                    </Row> */}
                    {
                        // props?.uploadedFileList.length > 0 &&
                        <div className="tableOfPreAuth">
                            <Card style={{ margin: "20px 30px" }}>
                                <Table
                                    dataSource={props?.uploadedInvestigationFileList || []}
                                    columns={props?.uploadedFileColumns}
                                    pagination={false}
                                    bordered
                                    style={{
                                        // width: "95%",
                                        // margin: "10px auto",
                                        textAlign: "center",
                                    }}
                                />
                            </Card>
                        </div>}
                </div>
            </>
        )
    }

    const renderCareTeamDetailsForm = () => {
        return (
            <>
                <div>
                    <Row>
                        <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "15px" }}>
                            <label style={{ alignSelf: "center" }}>Select a Doctor</label>
                            <Form.Item
                                // name="selectedDoctor"
                                noStyle
                            >
                                <Select
                                    placeholder="Select Doctor"
                                    style={{ width: 200 }}
                                    value={selectedDoctor}
                                    onChange={handleDoctorChange}
                                >
                                    {doctors.map((doctor, index) => (
                                        <Option key={index} value={doctor.docid}>{doctor.docname}</Option>
                                    ))}
                                    <Option value="OTHER">OTHER</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    {selectedDoctor && (
                        <Row gutter={20}>
                            <Col span={6}>
                                <Form.Item
                                    name="doctorName"
                                    label="Name"
                                >
                                    <Input
                                        placeholder="Enter doctor's name"
                                        style={{ marginBottom: "10px" }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name="doctorRegistrationId"
                                    label="Registration ID"
                                    rules={[
                                        { pattern: /^[0-9.]+$/, message: 'Please enter numeric values only' }
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter registration ID"
                                        style={{ marginBottom: "10px" }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name="doctorQualification"
                                    label="Qualification"
                                >
                                    <Input
                                        placeholder="Enter qualification"
                                        style={{ marginBottom: "10px" }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name="doctorMobileNo"
                                    label="Mobile No."
                                >
                                    <Input
                                        placeholder="Enter mobile number"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}
                </div>
            </>
        )
    }

    // Handle form field changes
    // const handleFieldChange = (field: any, value: any) => {
    //     setFormData({ ...formData, [field]: value });
    // };

    const doctorList = [
        { id: 1, doctorName: "Dr. John Doe", doctorRegistrationId: "12345", doctorQualification: "MD", doctorMobileNo: "123-456-7890" },
        { id: 2, doctorName: "Dr. Jane Smith", doctorRegistrationId: "67890", doctorQualification: "MBBS", doctorMobileNo: "987-654-3210" },
    ];

    const handleImplantChange = (value: number) => {
        const filterImplant = implantSampleData.find(item => item?.id === value) || null
        setNewImplant({ ...newImplant, implant: filterImplant })
    }

    const handleCategorySearch = (value: string) => {
        setCategory(value);
        const lowerCaseValue = value.toLowerCase();
        if (patients?.schemeMetaData?.portalMetaDataIdsList?.length) {
            // const diagnosisList = await fetchDiagnosis(patients?.schemeMetaData?.portalMetaDataIdsList[0], value)
            dispatch(getDiagnosis({ portalMetaDataId: patients?.schemeMetaData?.portalMetaDataIdsList[0], searchTerm: value }))
        }

        setNewDiagnosis((prev) => ({
            ...prev,
            diagnosis: "",
            // diagnosisId: "",
            diagnosisCode: "",
        }))
    };

    const handleDiagnosisSelect = (theCode: string) => {
        const selectedOption = diagnosisOptions.find((option) => option.theCode === theCode);
        if (selectedOption) {
            setNewDiagnosis({
                ...newDiagnosis,
                diagnosis: selectedOption.title,
                // diagnosisId: selectedOption.diagnosisId,
                diagnosisCode: selectedOption.theCode,
            });
        }
    };

    const handleAddDiagnosis = () => {
        if (newDiagnosis.diagnosis && newDiagnosis.diagnosisCode && newDiagnosis.type) {
            setDiagnosisData((prev) => [...prev, newDiagnosis]);
        }
        setCategory("")
    };

    // const handleManualDoctorInputChange = (e: any) => {
    //     const { name, value } = e.target;
    //     setFormData((prevDetails) => ({
    //         ...prevDetails,
    //         [name]: value
    //     }));
    // };

    const handleDoctorChange = (value: any) => {
        if (value === 'OTHER') {
            setSelectedDoctor(value); // Reset doctor selection when 'OTHER' is selected
            props?.form.setFieldsValue({
                doctorName: "",
                doctorRegistrationId: "",
                doctorQualification: "",
                doctorMobileNo: ""
            })
            // setFormData((prevDetails) => ({
            //     ...prevDetails,
            //     doctorName: "",
            //     doctorRegistrationId: "",
            //     doctorQualification: "",
            //     doctorMobileNo: ""
            // }));
        } else {
            setSelectedDoctor(value); // Set the selected doctor from the list
            const selectedDoc = doctors.find(doctor => doctor.docid === value);
            selectedDoc &&
                props?.form.setFieldsValue({
                    doctorName: selectedDoc?.docname || "",
                    doctorRegistrationId: selectedDoc?.docregnum || "",
                    doctorQualification: selectedDoc?.docqualification || "",
                    doctorMobileNo: selectedDoc?.doccontactnumber || ""
                })
            // setFormData((prevDetails) => ({
            //     ...prevDetails,
            //     doctorName: selectedDoc?.doctorName || "",
            //     doctorRegistrationId: selectedDoc?.doctorRegistrationId || "",
            //     doctorQualification: selectedDoc?.doctorQualification || "",
            //     doctorMobileNo: selectedDoc?.doctorMobileNo || ""
            // }));
        }
    };

    // const handleAddDiagnosis = (): void => {
    //     if (!newDiagnosis.diagnosis || !newDiagnosis.type) return;
    //     setDiagonsisData([...diagonsisData, { key: diagnosisCount.toString(), no: `${diagnosisCount}.`, ...newDiagnosis }]);
    //     setDiagnosisCount(diagnosisCount + 1);
    //     setNewDiagnosis({ diagnosis: "", type: "Primary" });
    // };

    const handleTreatmentDataChange = (fieldName: string, data: any) => {
        switch (fieldName) {
            case "speciality":
                const formattedSpecialityData = { id: data?.value, name: data?.label }
                setNewTreatmentPlan({ ...newTreatmentPlan, speciality: formattedSpecialityData })
                break;

            case "procedure":
                // if (!data?.label?.toLowerCase()?.includes("unspecified")) {
                    const formattedProcedureData = { id: data?.value, name: data?.label, procedureAmount: null, procedureName: null }
                    const selectedProcedure = data?.data
                    setNewTreatmentPlan({ ...newTreatmentPlan, procedure: formattedProcedureData, stratification: {} });
                    if (portalMetaData?.portalMetaDataIdsList[0]) {
                        selectedProcedure?.isstratificationapplicable == "Y" && dispatch(getStratifications({ portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0], procedureCode: selectedProcedure?.procedurecode }));
                    }
                // }
                break;
            
            case "procedureName":
                const formattedProcedureDataWithName = {...newTreatmentPlan?.procedure, procedureName: data, }
                setNewTreatmentPlan({ ...newTreatmentPlan, procedure: formattedProcedureDataWithName, stratification: {} });
                break;

            case "procedureAmount":
                const formattedProcedureDataWithAmount = { ...newTreatmentPlan?.procedure, procedureAmount: data }
                setNewTreatmentPlan({ ...newTreatmentPlan, procedure: formattedProcedureDataWithAmount, stratification: {} });
                break;

            case "stratification":
                const formattedStratificationData = { id: data?.value, name: data?.label }
                // const formattedStratificationData = stratifications.find((item)=> item.stratificationid == value) || {};
                setNewTreatmentPlan({ ...newTreatmentPlan, stratification: formattedStratificationData })
                break;

            case "numberOfDaysPerUnits":
                setNewTreatmentPlan({ ...newTreatmentPlan, numberOfDaysPerUnits: data })
                break;

            case "ichiCode":
                // const formattedIchiCodeData = specialities.find((item)=> item.stratificationid == value) || {};
                // setNewTreatmentPlan({...newTreatmentPlan, ichiCode: value})
                break;

            default:
                break;
        }
    }
    
    const handleAddTreatmentPlan = (): void => {
        if (!newTreatmentPlan?.procedure ||
            !newTreatmentPlan?.speciality
            // !newTreatmentPlan?.numberOfDaysPerUnits
        ) {
            message.error("Please, fill all required field!")
            return
        };
        const formatedTreatmentPlanData = {
            speciality: newTreatmentPlan?.speciality,
            procedure: {id: newTreatmentPlan?.procedure?.id || null, name: newTreatmentPlan?.procedure?.name, procedureName: newTreatmentPlan?.procedure?.procedureName, procedureAmount: newTreatmentPlan?.procedure?.procedureAmount},
            stratification: newTreatmentPlan?.stratification || null,
            numberOfDaysPerUnits: newTreatmentPlan?.numberOfDaysPerUnits,
            // ichiCode : newTreatmentPlan?.ichiCode,

        }
        setTreatmentPlansData([...treatmentPlansData, { ...formatedTreatmentPlanData }]);
        setTreatmentPlanCount(diagnosisCount + 1);
        setNewTreatmentPlan({
            speciality: {},
            procedure: {},
            stratification: {},
            numberOfDaysPerUnits: 1,
            // ichiCode: "",
        });
    };

    const handleAddImplant = (): void => {
        if (!newImplant?.implant || !newImplant?.quantity) return;
        setImplantData([...implantData, { document: null, ...newImplant }]);
        // setTreatmentPlanCount(diagnosisCount + 1);
        setNewImplant({
            implant: null,
            quantity: 1,
        });
    };

    const handleDeleteDiagnosis = (index: number): void => {
        setDiagnosisData(diagnosisData.filter((_, i) => i !== index));
    };

    const handleDeleteTreatmentPlan = (index: number): void => {
        setTreatmentPlansData(treatmentPlansData.filter((_, i) => i !== index));
    };

    const handleDeleteImplant = (index: number): void => {
        setImplantData(implantData.filter((_, i) => i !== index));
    };

    const handleUpdateAsDraftToPortal = async () => {
        try {
            const formData = await props?.form.getFieldsValue(true);
            if (schemeMetaDataId) {
                const formattedSurgeryDate = formData.surgeryDate
                    ? dayjs(formData.surgeryDate).format(dateFormat)
                    : null;
                const formattedAdmissionDate = formData.admissionDate
                    ? dayjs(formData.admissionDate).format(dateFormat)
                    : null;
                const formatedData = {
                    ...formData,
                    surgeryDate: formattedSurgeryDate,
                    admissionDate: formattedAdmissionDate,
                    treatmentPlansData,
                    diagnosisData,
                    // implantData,
                    // documentList: props?.uploadedFileList,
                    investigationList: props?.uploadedInvestigationFileList || [],
                    implantList: props?.uploadedImplantFileList || [],
                }
                const payloadData = {
                    params: {
                        caseId: caseId,
                        visitId: visitId,
                        casePreAuthId: casePreAuthId
                    },
                    data: {
                        beneficiaryId: patients?.fetchBasicDetails?.casesResponse?.memberId,
                        schemeMetaDataId: schemeMetaDataId,
                        portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0],
                        casePreAuthId: 0,
                        casePreAuthOthersRequest: formatedData,
                        claimOnPortal: true,
                        action: 'SUBMIT',
                        hospitalId: '',
                        totalAmount: "",
                    }
                }
                const res = await updateAyushBPreAuth(payloadData);
                res && message.success("PreAuth Updated Successfully!")
                setDisabledForm(true);
                props?.handleGetData();

            }
        } catch (error: any) {
            const errorMsg = error?.response?.data || error?.message || "Please, Try again after sometime";
            message.error(errorMsg);
        }
    };

    const handleSaveAsDraftToPortal = async () => {
        try {
            const formData = await props?.form.getFieldsValue(true);
            if (schemeMetaDataId) {
                const formattedSurgeryDate = formData.surgeryDate
                    ? dayjs(formData.surgeryDate).format(dateFormat)
                    : null;
                const formattedAdmissionDate = formData.admissionDate
                    ? dayjs(formData.admissionDate).format(dateFormat)
                    : null;
                const formatedData = {
                    ...formData,
                    surgeryDate: formattedSurgeryDate,
                    admissionDate: formattedAdmissionDate,
                    treatmentPlansData,
                    diagnosisData,
                    investigationList: props?.uploadedInvestigationFileList || [],
                    implantList: props?.uploadedImplantFileList || [],
                    // implantData,
                    // documentList: props?.uploadedFileList,
                }
                const payloadData = {
                    params: {
                        caseId: caseId,
                        visitId: visitId
                    },
                    data: {
                        beneficiaryId: patients?.fetchBasicDetails?.casesResponse?.memberId,
                        schemeMetaDataId: schemeMetaDataId,
                        portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0],
                        casePreAuthId: 0,
                        casePreAuthOthersRequest: formatedData,
                        claimOnPortal: true,
                        action: 'SUBMIT',
                        hospitalId: '',
                        totalAmount: "",
                    }
                }

                const res = await createAyushBPreAuth(payloadData);
                res && message.success("PreAuth Saved Successfully!")

                props?.handleGetData();
            }
        } catch (error: any) {
            const errorMsg = error?.response?.data || error?.message || "Please, Try again after sometime";
            message.error(errorMsg);
        }
    };

    const handleSubmitToPortal = async () => {
        try {
            await props?.form.validateFields();
            if (props?.uploadedInvestigationFileList?.length <= 0) {
                errorMessage("Please, add investigation data!");
                return
            }
            // if(props?.uploadedImplantFileList?.length <= 0) {
            //     errorMessage("Please, add implant data!");
            //     return
            // }
            const formData = await props?.form.getFieldsValue(true)
            if (schemeMetaDataId) {
                const formattedSurgeryDate = formData.surgeryDate
                    ? dayjs(formData.surgeryDate).format(dateFormat)
                    : null;
                const formattedAdmissionDate = formData.admissionDate
                    ? dayjs(formData.admissionDate).format(dateFormat)
                    : null;

                const formatedData = {
                    ...formData,
                    surgeryDate: formattedSurgeryDate,
                    admissionDate: formattedAdmissionDate,
                    treatmentPlansData,
                    diagnosisData,
                    // implantData,
                    // documentList: props?.uploadedFileList,
                    investigationList: props?.uploadedInvestigationFileList || [],
                    implantList: props?.uploadedImplantFileList || [],
                }
                const payloadData = {
                    params: {
                        caseId: caseId,
                        visitId: visitId
                    },
                    data: {
                        beneficiaryId: patients?.fetchBasicDetails?.casesResponse?.memberId,
                        schemeMetaDataId: schemeMetaDataId,
                        portalMetaDataId: portalMetaData?.portalMetaDataIdsList[0],
                        casePreAuthId: 0,
                        casePreAuthOthersRequest: formatedData,
                        claimOnPortal: true,
                        action: 'SUBMIT',
                        hospitalId: '',
                        totalAmount: "",
                    }
                }


                const res = await postAyushBPreAuth(payloadData);
                res && message.success("PreAuth Submitted Successfuly!")

                props?.handleGetData();

            }
        } catch (error: any) {
            if (error?.errorFields?.length) {
                errorMessage("Please, fill all required fields!");
            } else {
                const errorMsg = error?.response?.data || error?.message || "Please, Try again after sometime";
                message.error(errorMsg);
            }
        }
    };

    const DiagonsisColumns = [
        {
            title: "S.No.",
            dataIndex: "no",
            key: "no",
            width: 80,
            render: (_: string, r_: DiagnosisData, index: number) => <span style={{ fontWeight: "bold" }}>{(index + 1)}</span>,
        },
        {
            title: "Diagnosis",
            dataIndex: "diagnosis",
            key: "diagnosis",
            render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
        },
        {
            title: "Diagnosis Type",
            dataIndex: "type",
            key: "type",
            render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_: any, record: DiagnosisData, index: number) => (
                <Space size="middle">
                    <DeleteOutlined
                        style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
                        onClick={() => handleDeleteDiagnosis(index)}
                    />
                </Space>
            ),
        },
    ];

    const TreatmentPlanColumns = [
        {
            title: "S.No.",
            dataIndex: "no",
            key: "no",
            width: 80,
            render: (_: string, r_: TreatmentPlan, index: number) => <span style={{ fontWeight: "bold" }}>{(index + 1)}</span>,
        },
        {
            title: "Speciality",
            dataIndex: "speciality",
            key: "speciality",
            render: (text: JsonObject) => <span style={{ fontWeight: "bold" }}>{text?.name}</span>,
        },
        {
            title: "Procedure",
            dataIndex: "procedure",
            key: "procedure",
            render: (text: JsonObject) => <span style={{ fontWeight: "bold" }}>{text?.name}</span>,
        },
        {
            title: "Stratification",
            dataIndex: "stratification",
            key: "stratification",
            render: (text: JsonObject) => <span style={{ fontWeight: "bold" }}>{text?.name}</span>,
        },
        {
            title: "No. of Days/Units",
            dataIndex: "numberOfDaysPerUnits",
            key: "numberOfDaysPerUnits",
            render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
        },
        // {
        //     title: "ICHI Code",
        //     dataIndex: "ichiCode",
        //     key: "ichiCode",
        //     render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
        // },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_: any, record: TreatmentPlan, index: number) => (
                <Space size="middle">
                    <DeleteOutlined
                        style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
                        onClick={() => handleDeleteTreatmentPlan(index)}
                    />
                </Space>
            ),
        },
    ];

    const ImplantColumns = [
        {
            title: "S.No.",
            dataIndex: "implant",
            key: "implant",
            render: (_: string, record: any, idx: number) => <span style={{ fontWeight: "bold" }}>{(idx + 1)}</span>,
        },
        {
            title: "Implant",
            dataIndex: "implant",
            key: "implant",
            render: (text: any) => <span style={{ fontWeight: "bold" }}>{text?.name}</span>,
        },
        {
            title: "Document",
            dataIndex: "document",
            key: "document",
            render: (text: any) => <span style={{ fontWeight: "bold" }}>{text?.documentName}</span>,
        },
        {
            title: "Amount",
            dataIndex: "implant",
            key: "implant",
            render: (text: any) => <span style={{ fontWeight: "bold" }}>{text?.amount}</span>,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_: any, record: Implant, index: number) => (
                <Space size="middle">
                    <DeleteOutlined
                        style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
                        onClick={() => handleDeleteImplant(index)}
                    />
                </Space>
            ),
        },
    ];

    // Handler for tab changes
    const handleMedicalTabChange = (tab: TabType) => {
        setActiveMedicalTab(tab);
    };

    const handleAdmissionTabChange = (tab: TabType) => {
        setActiveAdmissionTab(tab);
    };

    const handleTreatmentTabChange = (tab: TabType) => {
        setActiveTreatmentTab(tab);
    };

    // Custom tab button style
    const getTabButtonStyle = (isActive: boolean) => {
        return isActive
            ? {
                background: "#008B8B",
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
                borderBottomLeftRadius: "0px",
                borderBottomRightRadius: "0px",
                fontWeight: "700",
                height: "35px",
                boxShadow: "0px -1px 4px 0px #00000040 inset",
                color: "#fff"
            }
            : {
                border: "none",
                boxShadow: "none",
                height: "35px",
                color: "#575757",
            };
    };

    return (
        <div style={{ padding: "20px", marginTop: "20px" }}>
            <Card
                className="preAuthCard"
                style={{
                    maxWidth: "100%",
                    margin: "auto",
                    overflow: "hidden",
                    padding: 0,
                    backgroundColor: "#FBFBFB",
                    boxShadow: "0px -1px 4px 0px #00000040 inset",
                }}
            >
                <Steps
                    current={props?.activeStep}
                    style={{
                        marginBottom: 10,
                        backgroundColor: "#E5F3F3",
                        padding: "20px 25px",
                        boxShadow: "0px -1px 4px 0px #00000040 inset",
                        borderBottom: "none",
                    }}
                >
                    <Step title="MEDICAL INFORMATION" />
                    <Step title="ADMISSION INFORMATION" />
                    <Step title="TREATMENT" />
                </Steps>
                <div style={styles.editAndSaveButtonDesign}>
                    <Space>
                        {props?.stageStatus !== 4 && casePreAuthId ? (
                            !disabledForm ? (
                                <Button
                                    // type="primary"
                                    style={styles.saveEditButton}
                                    icon={<SaveOutlined />}
                                    onClick={handleUpdateAsDraftToPortal}

                                // disabled={!isFormValid}
                                >
                                    Save
                                </Button>
                            ) : (
                                <Button
                                    style={styles.editButton}
                                    icon={<EditOutlined />}
                                    onClick={() => setDisabledForm(false)}
                                >
                                    Edit
                                </Button>
                            )
                        ) : (
                            <></>
                        )}
                    </Space>
                </div>
                <div style={{ padding: "15px 0" }}>
                    {/* <Form
                    form={props?.form}
                    // name="careTeamDetailsForm"
                    // disabled={true}
                    layout="vertical" style={{ padding: "15px 0" }}> */}
                    <div>
                        <div
                            hidden={!(props?.activeStep === 0)}
                        >
                            {renderMedicalForm()}
                        </div>
                        <div
                            hidden={!(props?.activeStep === 1)}
                        >
                            {renderAdmissionForm()}
                        </div><div
                            hidden={!(props?.activeStep === 2)}
                        >
                            {renderTreatmentForm()}
                        </div>
                    </div>
                    {/* </Form> */}
                </div>
                <div
                    style={{
                        marginTop: 20,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "30px",
                        borderTop: "1px solid #D9D9D9",
                        padding: "15px 20px",
                    }}
                >
                    {props?.activeStep != 0 &&
                        <Button
                            disabled={props?.activeStep === 0}
                            style={{
                                border: "none",
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                color: "#575757",
                                fontWeight: "bold",
                            }}
                            onClick={props?.handlePrevious}
                        >
                            &lt; PREVIOUS
                        </Button>}
                    {props?.activeStep !== 2 && (
                        <div style={{ width: "18%" }}>
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: "#008B8B",
                                    color: "#fff",
                                    boxShadow: "0px 2px 8px 0px #00000040",
                                    width: "100%",
                                }}
                                onClick={props?.handleNext}
                            >
                                SAVE AND CONTINUE
                            </Button>
                        </div>
                    )}
                    {props?.activeStep === 2 && (
                        <>
                            {
                                (props?.stageStatus !== 4 && props?.stageStatus !== 2) &&
                                (<div style={{ width: "16%" }}>
                                    <Button
                                        type="primary"
                                        style={{
                                            backgroundColor: "#008B8B",
                                            color: "#fff",
                                            boxShadow: "0px 2px 8px 0px #00000040",
                                            width: "100%",
                                        }}
                                        onClick={casePreAuthId ? handleUpdateAsDraftToPortal : handleSaveAsDraftToPortal}
                                    >
                                        {casePreAuthId ? "UPDATE AS DRAFT" : "SAVE AS DRAFT"}
                                    </Button>
                                </div>)
                            }
                            {
                                (props?.stageStatus !== 4 && props?.stageStatus !== 2) ?
                                    (<div style={{ width: "16%" }}>
                                        <Button
                                            type="primary"
                                            style={{
                                                backgroundColor: "#008B8B",
                                                color: "#fff",
                                                boxShadow: "0px 2px 8px 0px #00000040",
                                                width: "100%",
                                            }}
                                            onClick={handleSubmitToPortal}
                                        >
                                            SUBMIT TO PORTAL
                                        </Button>
                                    </div>) :
                                    (props?.stageStatus == 4 || props?.stageStatus == 2) && (<div style={{ width: "16%" }}>
                                        <Button
                                            type="primary"
                                            style={{
                                                backgroundColor: "#008B8B",
                                                color: "#fff",
                                                boxShadow: "0px 2px 8px 0px #00000040",
                                                width: "100%",
                                            }}
                                            onClick={() => {
                                                props?.setMoveToNext(true);
                                            }}
                                        >
                                            NEXT: {props?.nextStage?.visitStage}
                                        </Button>
                                    </div>)
                            }
                        </>
                    )}
                </div>
            </Card>
        </div>
    );
};